var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pageRoot" }, [
    _c("div", { staticClass: "heading" }, [
      _vm._v("Login History for " + _vm._s(_vm.userName))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bodySection" },
      [_c("LoginRecordsTable", { attrs: { userName: _vm.userName } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }